import React, { useEffect, useState } from 'react';
import { LogoMark } from '../brand/LogoMark';
import { ButtonLink } from '../ui/ButtonLink';
import { HERO_ID } from '../sections/Hero';
export function SiteNav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Phones only: the hero shows the full lockup, so the nav mark waits until the hero has scrolled away.
  const [pastHero, setPastHero] = useState(false);
  useEffect(() => {
    const el = document.getElementById(HERO_ID);
    if (!el) return;
    const io = new IntersectionObserver(([entry]) => setPastHero(!entry.isIntersecting), {
      rootMargin: '-64px 0px 0px 0px'
    });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return <header className={`sticky top-0 z-40 border-b transition-[background-color,border-color] duration-200 ease-quiet ${scrolled ? 'border-fog bg-paper' : 'border-transparent bg-transparent'}`} data-id="element-35" data-mp="dhrwyzokf1c3">
      <nav aria-label="Primary" className="mx-auto flex h-16 max-w-page items-center justify-between gap-6 px-6 md:h-[72px] md:px-12 xl:px-20" data-id="element-36" data-mp="17b93nmy8pzgs">
        <a href="#main" aria-label="40 Yawgoo Consulting, back to top" className={`-m-1 inline-flex rounded-full p-1 transition-[opacity,visibility] duration-200 ease-quiet ${pastHero ? '' : 'max-md:invisible max-md:opacity-0'} focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink`} data-id="element-37" data-mp="y9sypuq72pjy">
          <LogoMark size={38} label="" data-id="element-38" data-mp="1h6klie4y3msr" />
        </a>
        <ButtonLink href="#contact" size="nav" variant={scrolled ? 'primary' : 'secondary'} data-id="element-39" data-mp="2emzumchgu3sr">
          Contact
        </ButtonLink>
      </nav>
    </header>;
}